var map = {
	"./icon-authed.svg": "1873",
	"./icon-close-response.svg": "7f9f",
	"./icon-empty.svg": "94e5",
	"./icon-weixin.svg": "ce76",
	"./icon-wx-authed.svg": "2b0e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf87";